<div class="row pt-4 px-4" *ngIf="show">
  <div class='col-12'>
    No data available for the selected filters.
  </div>
</div>

<ng-container *ngIf="os">
  <ng-container *ngIf="os == 'unk-a'">
    No data available for this bundle ID.
  </ng-container>

  <ng-container *ngIf="os != 'unk-a'">
    <ng-content></ng-content>
  </ng-container>
</ng-container>